// import React, { useState } from "react";
// import { Box, IconButton, TextField } from "@mui/material";
// import SendIcon from "@mui/icons-material/Send";
// import AttachFileIcon from "@mui/icons-material/AttachFile";

// export default function ChatInput({ onSend }) {
//   const [text, setText] = useState("");

//   return (
//     <Box
//       sx={{
//         p: 2,
//         borderTop: "1px solid #e5e7eb",
//         display: "flex",
//         alignItems: "center",
//         gap: 1
//       }}
//     >
//       <IconButton component="label">
//         <AttachFileIcon />
//         <input hidden type="file" />
//       </IconButton>

//       <TextField
//         fullWidth
//         placeholder="Type your message..."
//         value={text}
//         onChange={(e) => setText(e.target.value)}
//         onKeyDown={(e) => e.key === "Enter" && onSend(text)}
//       />

//       {(text || text.length > 0) && (
//         <IconButton onClick={() => { onSend(text); setText(""); }}>
//           <SendIcon />
//         </IconButton>
//       )}
//     </Box>
//   );
// }
import React, { useState } from "react";
import {
  
  IconButton,
  TextField,
  Paper,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";

export default function ChatInput({ onSend }) {
  const [text, setText] = useState("");
  const [files, setFiles] = useState([]);

  const canSend = text.trim() || files.length > 0;

  return (
    <Paper
      elevation={3}
      sx={{
        p: 1.5,
        mx: 2,
        mb: 2,
        borderRadius: "16px",
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <IconButton component="label">
        <AttachFileIcon />
        <input
          hidden
          type="file"
          multiple
          onChange={(e) => setFiles([...e.target.files])}
        />
      </IconButton>

      <TextField
        fullWidth
        placeholder="Ask IntelliTutor..."
        variant="standard"
        InputProps={{ disableUnderline: true }}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />

      {canSend && (
        <IconButton
          color="primary"
          onClick={() => {
            onSend(text, files);
            setText("");
            setFiles([]);
          }}
        >
          <SendIcon />
        </IconButton>
      )}
    </Paper>
  );
}
